import React, { useState, useEffect } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { TextField } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import axios from 'axios'

const initialValues = {
    cardLimit: '',
    fingerprint: '',


}

export default function Create(props) {
  const { show, onHide, onFingerLimits, skip,
    take,
    filterInputs,
    orderBy,
    sortField, } = props
  const [isError, setIsError] = useState('')
  const [isLoading, setIsLoading] = useState(false);

  const CreateSchema = Yup.object().shape({
    cardLimit: Yup.string()
      .required('Kart limiti tələb olunur.'),
      fingerprint: Yup.string()
      .required('Barmaq izi tələb olunur.'),
   
  })

  const getInputClasses = (filedName) => {
    if (formik.touched[filedName] && formik.errors[filedName]) {
      return true
    }
    if (formik.touched[filedName] && !formik.errors[filedName]) {
      return false
    }

    return false
  }

  const onPostFingerLimit = (values, resetForm, setSubmitting) => {
    setIsLoading(true);

    const fingerLimit = {
        cardLimit: values.cardLimit,
        fingerprint: values.fingerprint,

   
    }
    axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}default-limit `,
      data: fingerLimit,
    
    })
      .then((res) => {
        onFingerLimits(orderBy, sortField, skip, take, filterInputs)
        setSubmitting(false)
        resetForm()
        onHide(false)
        setIsLoading(false);

      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined"
            ? err.response.data.message
            : err.message;
        setIsError(message);
        setIsLoading(false);
      });
  }

  const formik = useFormik({
    initialValues,
    validationSchema: CreateSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPostFingerLimit(values, resetForm, setSubmitting)
    },
  })

  const resetForm = () => {
    onHide()
    formik.resetForm()
  }

  useEffect(() => {
    setIsError('')
  }, [show])

  return (
    <Modal
      size="md"
      aria-labelledby="create"
      centered
      className="modal pr-0"
      show={show}
      onHide={resetForm}
    >
      <form onSubmit={formik.handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="create">Əlavə et</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 pl-4 pr-4">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="fingerprint"
                    name="fingerprint"
                    label="Barmaq izi"
                    placeholder="Barmaq izi"
                    type='number'
                    InputProps={{inputProps:{min:0}}}
                    onKeyPress={(event) => {
                      if (event?.key === '-' || event?.key === '+') {
                        event.preventDefault();
                      }
                    }}
                    className="w-100"
                    error={getInputClasses('fingerprint')}
                    {...formik.getFieldProps('fingerprint')}
                  />
                </div>
                {formik.touched.fingerprint && formik.errors.fingerprint ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.fingerprint}</div>
                  </div>
                ) : null}
                </div>
                <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="cardLimit"
                    name="cardLimit"
                    label="Kart limiti"
                    placeholder="Kart limiti"
                    className="w-100"
                    type='number'
                    InputProps={{inputProps:{min:0}}}
                    onKeyPress={(event) => {
                      if (event?.key === '-' || event?.key === '+') {
                        event.preventDefault();
                      }
                    }}
                    error={getInputClasses('cardLimit')}
                    {...formik.getFieldProps('cardLimit')}
                  />
                </div>
                {formik.touched.cardLimit && formik.errors.cardLimit ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.cardLimit}</div>
                  </div>
                ) : null}
              {isError && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block MuiFormLabel-root Mui-error">
                    {isError}
                  </div>
                </div>
              )}
            </div>
            </div>

          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              onHide(false)
              formik.resetForm()
            }}
          >
            Ləğv et
          </Button>
          <Button type="submit" className={isLoading ? "px-9" : ""}>
            <span>Əlavə et</span>
            {isLoading && <span className="ml-3 spinner spinner-white"></span>}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  )
}